type regionType = {
    code: number;
    en_name: string;
};

export const regionList: regionType[] = [
    { code: 11, en_name: "Seoul" },
    { code: 21, en_name: "Busan" },
    { code: 22, en_name: "Daegu" },
    { code: 23, en_name: "Incheon" },
    { code: 24, en_name: "Gwangju" },
    { code: 25, en_name: "Daejeon" },
    { code: 26, en_name: "Ulsan" },
    { code: 29, en_name: "Sejong" },
    { code: 31, en_name: "Gyeonggi-do" },
    { code: 32, en_name: "Gangwon-do" },
    { code: 33, en_name: "Chungcheongbuk-do" },
    { code: 34, en_name: "Chungcheongnam-do" },
    { code: 35, en_name: "Jeollabuk-do" },
    { code: 36, en_name: "Jeollanam-do" },
    { code: 37, en_name: "Gyeongsangbuk-do" },
    { code: 38, en_name: "Gyeongsangnam-do" },
    { code: 39, en_name: "Jeju" },
];

export const seoulList: regionType[] = [
    { code: 11, en_name: "Seoul" },
    { code: 11120, en_name: "Enpyeong-gu" },
    { code: 11150, en_name: "Yangcheon-gu" },
];

export const busanList: regionType[] = [
    { code: 21, en_name: "Busan" },
    { code: 21060, en_name: "Dongrae-gu" },
    // { code: 21010, en_name: "Jung-gu" },
    // { code: 21020, en_name: "Seo-gu" },
    // { code: 21030, en_name: "Dong-gu" },
];

export const daeguList: regionType[] = [
    { code: 22, en_name: "Daegu" },
    { code: 22310, en_name: "Dalseong-gun" },
    // { code: 22010, en_name: "Jung-gu" },
    // { code: 22020, en_name: "Dalseo-gu" },
    // { code: 22030, en_name: "Nam-gu" },
];

export const incheonList: regionType[] = [
    { code: 23, en_name: "Incheon" },
    { code: 23310, en_name: "Ganghwa-gun" },
    // { code: 23010, en_name: "Jung-gu" },
];

export const gwangjuList: regionType[] = [
    { code: 24, en_name: "Gwangju" },
    // { code: 24010, en_name: "Dong-gu" },
];

export const daejeonList: regionType[] = [
    { code: 25, en_name: "Daejeon" },
    // { code: 25010, en_name: "Dong-gu" },
];

export const ulsanList: regionType[] = [
    { code: 26, en_name: "Ulsan" },
    { code: 26010, en_name: "Ju-gu" },
    { code: 26040, en_name: "Buk-gu" },
    { code: 26310, en_name: "Ulju-gun" },
    // { code: 26010, en_name: "Dong-gu" },
];

export const sejongList: regionType[] = [
    { code: 29, en_name: "Sejong" },
    // { code: 29010, en_name: "Dong-gu" },
];

export const gyeonggidoList: regionType[] = [
    { code: 31, en_name: "Gyeonggi-do" },
    { code: 31280, en_name: "Yeoju-si" },
    { code: 31070, en_name: "Pyeongtaek-si" },
    { code: 31110, en_name: "Gwacheon-si" },
];

export const gangwondoList: regionType[] = [
    { code: 32, en_name: "Gangwon-do" },
    // { code: 32010, en_name: "Chuncheon-si" },
    // { code: 32020, en_name: "Wonju-si" },
    // { code: 32030, en_name: "Gangneung-si" },
    // { code: 32040, en_name: "Donghae-si" },
    // { code: 32050, en_name: "Taebaek-si" },
];

export const chungcheongbukdoList: regionType[] = [
    { code: 33, en_name: "Chungcheongbuk-do" },
    { code: 33030, en_name: "Jecheon-si" },
    { code: 33350, en_name: "Jincheon-gun" },
    { code: 33370, en_name: "Eumseong-gun" },
];

export const chungcheongnamdoList: regionType[] = [
    { code: 34, en_name: "Chungcheongnam-do" },
    { code: 34020, en_name: "Gongju-si" },
    { code: 34040, en_name: "Asan-si" },
    { code: 34330, en_name: "Buyeo-gun" },
    { code: 34070, en_name: "Gyeryong-si" },
];

export const jeollabukdoList: regionType[] = [
    { code: 35, en_name: "Jeollabuk-do" },
    { code: 35060, en_name: "Gimje-si" },
];

export const jeollanamdoList: regionType[] = [
    { code: 36, en_name: "Jeollanam-do" },
    { code: 36010, en_name: "Mokpo-si" },
    { code: 36330, en_name: "Gurye-gun" },
    { code: 36400, en_name: "Haenam-gun" },
];

export const gyeongsangbukdoList: regionType[] = [
    { code: 37, en_name: "Gyeongsangbuk-do" },
    { code: 3701, en_name: "Pohang-si" },
    { code: 37011, en_name: "Pohang Buk-gu" },
    { code: 37012, en_name: "Pohang Nam-gu" },
    { code: 37030, en_name: "Gimcheon-si" },
    { code: 37050, en_name: "Gumi-si" },
    { code: 37070, en_name: "Yeongcheon-si" },
    // { code: 37010, en_name: "Andong-si" },
    // { code: 37020, en_name: "Gimcheon-si" },
    // { code: 37030, en_name: "Gumi-si" },
];

export const gyeongsangnamdoList: regionType[] = [
    { code: 38, en_name: "Gyeongsangnam-do" },
    { code: 38090, en_name: "Geoje-si" },
    { code: 38100, en_name: "Yangsan-si" },
    { code: 38320, en_name: "Haman-gun" },
    { code: 38330, en_name: "Changnyeong-gun" },
    { code: 38360, en_name: "Hadong-gun" },
    // { code: 38010, en_name: "Changwon-si" },
    // { code: 38020, en_name: "Miryang-si" },
    // { code: 38030, en_name: "Yangsan-si" },
];

export const jejudoList: regionType[] = [
    { code: 39, en_name: "Jeju" },
    { code: 39010, en_name: "Jeju-si" },
];
